import React, { useEffect, useMemo, useState } from "react";
import {
  FaTrash,
  FaEye,
  FaChevronLeft,
  FaChevronRight,
  FaSearch
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  getAssignedTeams,
  deleteTeamMapping
} from "../../services/teamService";

import "../users/UserListLayer.css";
import "./TeamListLayer.css";

const TeamListLayer = () => {
  const navigate = useNavigate();

  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    loadTeams();
  }, []);

  const loadTeams = async () => {
    setLoading(true);

    try {
      const res = await getAssignedTeams();

      if (res?.status === "success" && Array.isArray(res.data)) {
        setTeams(res.data);
      } else {
        setTeams([]);
      }

    } catch (error) {
      console.error(error);
      setTeams([]);
    }

    setLoading(false);
  };

  /* ================= FILTER ================= */

  const filteredTeams = useMemo(() => {
    return teams.filter((t) =>
      t.tm_name?.toLowerCase().includes(search.toLowerCase())
    );
  }, [teams, search]);

  /* ================= PAGINATION ================= */

  const totalPages = Math.ceil(filteredTeams.length / limit) || 1;

  const paginatedTeams = useMemo(() => {
    const start = (page - 1) * limit;
    return filteredTeams.slice(start, start + limit);
  }, [filteredTeams, page, limit]);

  useEffect(() => {
    setPage(1);
  }, [search, limit]);

  /* ================= DELETE ================= */

  const handleDelete = async (tm_id) => {
    if (!window.confirm("Delete this team?")) return;

    const res = await deleteTeamMapping({ tm_id });

    if (res?.status === "success") {
      loadTeams();
    }
  };

  return (
    <div className="user-list-wrapper">

      <div className="user-list-card">

        {/* HEADER */}
        <div className="list-header">
          <h5>Assigned Teams</h5>
        </div>

        {/* FILTER BAR */}
        <div className="list-controls">

          <div className="search-box">
            <FaSearch className="search-icon" />

            <input
              type="text"
              placeholder="Search Team Manager..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="page-size">
            <label>Show</label>

            <select
              value={limit}
              onChange={(e) => setLimit(Number(e.target.value))}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>

            <span>entries</span>
          </div>

        </div>

        {/* TABLE */}

        {loading ? (
          <p style={{ textAlign: "center" }}>Loading...</p>
        ) : (
          <div className="table-responsive">

            <table className="user-table">

              <thead>
                <tr>
                  <th>#</th>
                  <th>Team Manager</th>
                  <th>Total Sales Executive</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>

                {paginatedTeams.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      No Teams Found
                    </td>
                  </tr>
                ) : (
                  paginatedTeams.map((t, i) => (
                    <tr key={t.tm_id}>

                      <td>{(page - 1) * limit + i + 1}</td>

                      <td>{t.tm_name}</td>

                      <td>{t.sales_count}</td>

                      <td className="action-col">

                        <button
                          className="icon-btn view"
                          onClick={() => navigate(`/view-team/${t.tm_id}`)}
                        >
                          <FaEye />
                        </button>

                        <button
                          className="icon-btn delete"
                          onClick={() => handleDelete(t.tm_id)}
                        >
                          <FaTrash />
                        </button>

                      </td>

                    </tr>
                  ))
                )}

              </tbody>

            </table>

          </div>
        )}

        {/* PAGINATION */}

        {!loading && totalPages > 1 && (
          <div className="pagination">

            <button
              className="page-btn"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              <FaChevronLeft />
            </button>

            <span className="page-info">
              Page {page} of {totalPages}
            </span>

            <button
              className="page-btn"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              <FaChevronRight />
            </button>

          </div>
        )}

      </div>

    </div>
  );
};

export default TeamListLayer;